var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2653B0",
    fillRule: "evenodd",
    d: "M15.001 0h-15v15h15zm-4.25 7.5-.333 2.083H8.75V15h-2.5V9.583H4.376V7.5h1.875V5.833c0-1.875 1.208-2.916 2.917-2.916.541 0 1.125.083 1.666.166V5h-.958c-.917 0-1.125.458-1.125 1.042V7.5z",
    clipRule: "evenodd"
  })));
};
export default SvgFacebook;